import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Voucher } from '../models/voucher';
import { VouchersService } from '../services/vouchers.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-voucher-detail',
  templateUrl: './voucher-detail.component.html',
  styleUrls: ['./voucher-detail.component.scss'],
})
export class VoucherDetailComponent implements OnInit {
  voucher: Voucher;
  id: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private mainService: VouchersService,
    private authenticationService: AuthenticationService,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    const voucher: string = this.route.snapshot.paramMap.get('voucher');
    const t = this.authenticationService.getUserDetails();

    this.mainService.refreshVoucher(voucher, t['username'], t['security_token']).subscribe(data => {
      this.voucher = data;
    });
  }

  getUsagePercentage(): number {
    if (!this.voucher?.data_cap || !this.voucher?.data_consumption) {
      return 0;
    }
    return (this.voucher.data_consumption / this.voucher.data_cap) * 100;
  }

  formatUptime(seconds: number): string {
    if (!seconds) return '0 hrs';
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    
    if (hours > 0) {
      return `${hours} hr${hours > 1 ? 's' : ''} ${minutes} min`;
    }
    return `${minutes} min`;
  }

  goBack() {
    this.navCtrl.back();
  }

  renewVoucher() {
    // TODO: Implement voucher renewal
    console.log('Renew voucher clicked');
    this.router.navigate(['/client/topups']);
  }
}
